import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import bannerImg from "../assets/about-jai.png";
import locationImg from "../assets/location-pin.jpeg";



export const About = () => {
  return (
    <section id='about'>
        <Container>
            <Row className="justify-content-between">
                <Col xs={12} md={6} xl={6} className="d-none d-md-flex align-items-center"> 
                    <img src = {bannerImg} alt = "Header of Me"  style={{ 
                                    maxWidth: '100%', 
                                    height: 'auto', 
                                    width: window.innerWidth < 768 ? '250px' : '500px'}} />   
                </Col>

                <Col xs = {12} md = {6} xl = {6} className="d-flex align-items-center">
                    <div>
                        <h2  style={{fontWeight: 'bold', fontSize: '35px', marginBottom: '10px', color: '#4169e1'}}>About Me</h2>
                        
                        <h1 style={{fontWeight: 'bold', fontSize: '30px'}}> 
                            <span>Currently located in </span>
                            <img src = {locationImg} alt= "Location" style={{ width: '1em', height: '1em', verticalAlign: 'middle' }}/>
                            <span style={{color: 'crimson'}}>Los Angeles</span></h1>
                        <p>
                            🚀 As an agile and innovative software engineer specializing in 🏢 enterprise application development, 
                            I've honed my ability to excel 🌟 both when flying solo 🦅 and when synergizing within a team 🤝. 
                            My expertise 🛠️ spans a spectrum of technical landscapes, including Enterprise Software 💼, Web Development 🌐, and Machine Learning 🧠. 
                            This diverse skill set ignites my passion 🔥 for embracing and spearheading 🚀 advancements in technology, consistently pushing the envelope 📬 of digital possibilities. 🌟
                        </p>
                    </div>     
                </Col>
            </Row>
        </Container>
    </section>
  )
}
